import React, { Dispatch, FunctionComponent, ReactElement, SetStateAction, useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, Checkbox, Col, Descriptions, Dropdown, Flex, Form, Input, Layout, Menu, MenuProps, Row, Select, Tooltip, Upload, message, theme } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Header, Content, Footer } from 'antd/es/layout/layout';

import { UploadOutlined, AppstoreAddOutlined, DeleteOutlined, ClearOutlined } from '@ant-design/icons'

import CryptoJS from 'crypto-js';
import { ValidateStatus } from 'antd/es/form/FormItem';





const Login: FunctionComponent = (): ReactElement => {
    const [form] = Form.useForm();
    const [accountid,setAccountId]=useState(-1)
    const [locked,setlocked]=useState(false)
    interface EmailConfirmCodeProps {
        value?: string;
        onChange?: (value: string) => void;
      }
    const EmailConfirmCode:FunctionComponent<EmailConfirmCodeProps>=({value,onChange}):ReactElement=>{
        const [checkcode,setcheckcode]=useState("")
        
        return <div style={{
            display:'flex'
        }}>
        <Input value={checkcode} onChange={(e)=>{
            setcheckcode(e.target.value)
            onChange?.(e.target.value)

        }} /> <Button   
        style={{
            marginLeft:"5px"
        }}          
            type="text"
            disabled={locked}
            onClick={(ele)=>{
              setlocked(true)
              fetch('/prelogin',{
                method:'POST',
                headers:{
                  'Content-Type':'application/json'
                },
                body:JSON.stringify({
                  acc:form.getFieldValue('email'),
                  psd:CryptoJS.MD5(form.getFieldValue('password')).toString()
                })
              }).then(
                (e)=>{
                  
                  return e.json()
                }
              ).then(
                (rsp:{
                  code:number,
                  data?:number,
                  errormessage:string
                })=>{
                    if(rsp.code==0){
                        setAccountId(rsp.data||-1)
                    }else{
                        form.setFieldValue('password',null)
                        setlocked(false)
                        alert(rsp.errormessage)
                    }
                  
                }
              )
            }}
           >获取邮件验证码</Button>
    
        </div>
    }

    const onFinish = (values: any) => {
        fetch('login',{
          method:"POST",
          headers:{
            "Content-Type":"application/json"

          },
          body:JSON.stringify({
            code:form.getFieldValue('checkcode')
          })
        }).then(e=>e.json()).then((rsp:{
          code:number,
          data?:string,
          errormessage:string

        })=>{
          if(rsp.code!==0){
            alert("登录失败:"+rsp.errormessage)
          }else{
            window.location.href='/my'
          }
          
        })
      };
    return <div style={{
        display:'flex',
        justifyContent:'center'
    }}>
    <Form
        style={{
          margin:"80px auto"
        }}
    
      form={form}
      name="用户登录"
      onFinish={onFinish}

    >
      <Form.Item
        name="email"
        label="邮箱"
        rules={[
          {
            pattern:new RegExp(/^[\w\+\-]+@[\w\+\-]+\.[\w\+\-.]*[\w]+$/),
            message:"邮箱格式不正确"
          },
          {
            required: true,
            message: '必须填写邮箱',
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="password"
        label="密码"
        rules={[
          {
            required: true,
            message: '输入你的密码',
          },{
            validator:(_,value)=>{
                if(!( (/[\d]/.test(value))&&(/[A-Z]/.test(value))&&(/[a-z]/.test(value))  )){
                    return Promise.reject(new Error('必须包含数字大写字母小写字母'));
                }else{
                    if(value.length<9){
                        return Promise.reject(new Error('密码不少于九位'));
                    }else{
                        return Promise.resolve();
                    }
                }
            }
          }
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>


      <Form.Item
        noStyle
        dependencies={['email']}
        shouldUpdate={(prevValues, currentValues) => {

            return prevValues.email !== currentValues.email}  }
      >
        {({ getFieldValue }) =>{
       
          return getFieldValue('email')&&/^[\w\+\-]+@[\w\+\-]+\.[\w\+\-.]*[\w]+$/.test(getFieldValue('email'))? (
            <Form.Item
            shouldUpdate
            name="checkcode"
            label="邮件确认码"
           
            rules={[
                {
                    required:true,
                    message:"必须填写邮件确认码,以确认邮箱"
                },{
                    validator:(_,v:string)=>{
                        if(/[A-Za-z0-9]{6}/.test(v)){
                             return Promise.resolve();
    
    
                        }else{
                            return  Promise.reject(new Error('邮件确认码为6位字母或数字不区分大小写'));
                        }
                    }
                }
            ]}
    
          >
            <EmailConfirmCode />
            
    
    
    
          </Form.Item>
          ) : null
        }

        }
      </Form.Item>

      <Form.Item >
        <div style={{
        display:'flex',
        justifyContent:"space-between",
        alignItems:"baseline",
        marginLeft:"8%",
        width:"90%"
      }}>
        <div>
        <Button type="primary" htmlType="submit">
          登录
        </Button>
        <span style={{
          marginLeft:"5px",
          fontSize:"small"
        }}>
          或 
        <a style={{
          marginLeft:"5px",
        }} href='/register'>
          注册
        </a>

        </span>
        </div>
        <div>        <span style={{
          fontSize:"small"
        }}>
          
          <a href='/psdreset'>
            忘记密码？
          </a>
  
          </span>
          
        </div>

        </div>
  

      </Form.Item>

    </Form>
    </div>
}
export default Login

